class EnvConfiguration {
   REACT_EXTERNAL_API_URL = "http://localhost:57806/api/";
   // REACT_EXTERNAL_API_URL = "http://192.168.4.41/External_API/api/";
   DefaultUrl="http://localhost:3000/";

   // REACT_EXTERNAL_API_URL = "http://123.252.216.120:9595/External_API/api/";
   // DefaultUrl="http://123.252.216.120:9595/";
}
export default EnvConfiguration;
